import merge from 'lodash.merge';
import * as types from './types';
import { actionBuilder } from './actions';

// state has to include all nested keys required for the application processStep
// for Vue getters to be reactive
const state = {
  application: { externalId: '' },
  task: { definitionKey: '' },
  lastUpdated: 0,
  loading: false,
};

const getters = {
  definitionKey: state => state.task.definitionKey,
  externalId: state => state.application.externalId,
  isLoading: state => state.loading,
  lastUpdated: state => state.lastUpdated,
};

const mutations = {
  [types.LOADING]: (state, loading) => (state.loading = loading),
  [types.PROCESS_STEP_UPDATED]: (state, payload) => {
    state = merge(state, payload);
    // track time of last received API request
    // This used as key to force vue component re-render
    // https://michaelnthiessen.com/force-re-render
    state.lastUpdated = Date.now();
  },
};

const moduleBuilder = (client, router, customPostHooks) => {
  return {
    namespaced: true,
    state,
    actions: actionBuilder(client, router, customPostHooks),
    getters,
    mutations,
  };
};

export default {
  moduleBuilder,
  types,
};
